import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "budget" }
const _hoisted_3 = { class: "budget__row" }
const _hoisted_4 = { class: "budget__title" }
const _hoisted_5 = { class: "budget__value" }
const _hoisted_6 = {
  key: 0,
  class: "budget__row"
}
const _hoisted_7 = { class: "budget__title" }
const _hoisted_8 = { class: "budget__value" }
const _hoisted_9 = { class: "budget__row budget__row--total" }
const _hoisted_10 = { class: "budget__row--total__price" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "budget__tjm" }
const _hoisted_13 = { class: "budget__info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VJoyHighlight = _resolveComponent("VJoyHighlight")!
  const _component_VJoyWrapper = _resolveComponent("VJoyWrapper")!
  const _component_tooltip_info = _resolveComponent("tooltip-info")!

  return (_openBlock(), _createBlock(_component_tooltip_info, {
    title: _ctx.$msg('customer.brief.form.when.conditions.tooltip.budget.title.v2')
  }, {
    content: _withCtx(() => [
      _createVNode(_component_VJoyWrapper, {
        direction: "column",
        align: "stretch",
        "row-gap": "1",
        "column-gap": "1",
        "no-margin": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", { innerHTML: _ctx.contractLabel }, null, 8, _hoisted_1),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$msg('customer.brief.form.when.conditions.tooltip.budget.quote')), 1),
              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.formattedCurrency(_ctx.estimatedBudget.freelancerQuote)), 1)
            ]),
            (_ctx.companyFees)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$msg('customer.brief.form.when.conditions.tooltip.budget.fees')), 1),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.formattedCurrency(_ctx.estimatedBudget.fees)), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("p", null, _toDisplayString(_ctx.$msg('customer.brief.form.when.conditions.tooltip.budget.total')), 1),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.formattedCurrency(_ctx.estimatedBudget.total)), 1)
            ])
          ]),
          (_ctx.tjmRecommendation)
            ? (_openBlock(), _createBlock(_component_VJoyHighlight, {
                key: 0,
                level: "warning",
                "display-icon": true,
                class: "budget__highlight"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", { innerHTML: _ctx.tjmRecommendationLabel }, null, 8, _hoisted_11),
                    _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.formattedCurrency(_ctx.tjmRecommendation)), 1),
                    _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$msg('customer.brief.form.when.conditions.tooltip.budget.tjm.info')), 1)
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["title"]))
}